<template>
    <div class="stackBar" id="stackBar"></div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['lessontypeName', 'lessontypeValue', 'ApplicationMaxData', 'termId'],
    data() {
        return {
            type: {
                'applyNum': '教师应用总数',
                'conciseCourse': '简洁版',
                'hardPenSys': '硬笔体系课',
                'softPenSys': '软笔体系课',
                'syncCourse': '同步课程',
                'syncProject': '作品投影',
                'validAttendClassCount': '有效课程数',
                'videoProject': '视频投影',
                'wordOfDay': '每日一字',
            },
        };
    },
    // 计算属性
    computed: {
        series() {
            let that = this;
            const series = [];
            const keys = Object.keys(this.lessontypeValue);
            const colors = ['#4150d8', '#2ec181', '#ed7c2f', '#f2a93b'];
            keys.forEach((key, index) => {
                series.push({
                    name: that.type[key],
                    type: 'bar',
                    color: colors[index % colors.length],
                    stack: 'Ad',
                    barWidth: that.graphicRatio(16),
                    // barWidth: 30,
                    label: {
                        show: true,
                        color: '#fff',
                        fontSize: that.graphicRatio(12),
                    },
                    data: that.lessontypeValue[key].slice(0, 10),
                });
            });

            // 添加背景条
            series.push({
                color: new that.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                        offset: 0,
                        color: 'rgba(14, 40, 88,0)'
                    },
                    {
                        offset: 0.2,
                        color: 'rgba(14, 40, 88,0.8)'
                    },
                    {
                        offset: 0.9,
                        color: 'rgba(14, 40, 88,1)'
                    }
                ]),
                type: 'bar',
                z: 1,
                barWidth: that.graphicRatio(16),
                barGap: '-100%',
                data: that.ApplicationMaxData.slice(0, 10),
            });
            return series;
        }
    },
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        stackBar_graphics() {
            this.$echarts.init(document.getElementById("stackBar")).dispose();
            let that = this;
            let myChart = this.$echarts.init(
                document.getElementById("stackBar")
            );

            myChart.setOption({
                //鼠标滑过提示栏
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    },
                    formatter: (params) => {
                        let arr = [...params].slice(0, -1);
                        let str = '';
                        arr.forEach((item) => {
                            str += item.marker + item.seriesName + '：' + item.data + '<br />';
                        });
                        str = arr[0].name + '<br />' + str;
                        return str;
                    },
                },
                // dataZoom: [
                //     // 横向柱状图，y轴超过15条数据就会展示出来
                //     {
                //         type: 'inside', // 放大和缩小
                //         orient: 'vertical',
                //         show: obj.ydata.length > 15,
                //         start: 0,
                //         end: obj.ydata.length > 15 ? 30 : 100, // 控制初始化时展示的百分比数量
                //         height: 15,
                //         left: '5%',
                //         right: '5%',
                //         bottom: '2%',
                //         moveHandleSize: 0, //去掉进度条顶部的横向拉动进度条
                //     },
                // ],
                //图表选择栏
                legend: {
                    bottom: this.graphicRatio(3),
                    itemWidth: this.graphicRatio(14),
                    itemHeight: this.graphicRatio(14),
                    textStyle: {
                        color: '#fff',
                        fontSize: this.graphicRatio(12)
                    }
                },
                //图标离容器的距离
                grid: {
                    left: '5%',
                    right: '1%',
                    bottom: '10%',
                    top: '3%',
                    containLabel: true,
                },
                //x坐标轴
                xAxis: [
                    {
                        type: 'value',
                        axisTick: {
                            show: false,
                        },
                        boundaryGap: true,
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                    },
                ],

                //y坐标轴
                yAxis: [
                    {
                        type: 'category',
                        data: that.lessontypeName.slice(0, 10),
                        splitLine: {
                            show: false,
                        },
                        inverse: true,
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#2e76c4",
                                width: this.graphicRatio(1),
                                type: 'solid',
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#fff',
                                fontSize: this.graphicRatio(12),
                            },
                        },
                    },
                ],
                // 数据展示区域
                series: this.series,
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.stackBar_graphics()
    },
}
</script>
<style scoped>
.stackBar {
    width: 100%;
    height: 100%;
}
</style>